import { Briefcase, Gamepad2, Coins, Wand2, LayoutDashboard, LogOut, X, LayoutTemplate, Film } from "lucide-react";

const MACRO_VECTORS = [
  { key: "careers", label: "Careers", sub: "Pipelines · Resumes", icon: Briefcase },
  { key: "leisure", label: "Leisure", sub: "Media · Loops", icon: Gamepad2 },
  { key: "wealth", label: "Wealth", sub: "Credits · Ledgers", icon: Coins },
  { key: "creation", label: "Make a Video & Design", sub: "Create · Generate", icon: Wand2 },
  { key: "blueprint", label: "Design Studio", sub: "Sketch · Publish", icon: LayoutTemplate },
  { key: "editor", label: "Edit Video", sub: "Trim · Stylize · Post", icon: Film },
];

export default function QuickActionDrawer({ open, onClose, onAction }) {
  return (
    <>
      <div
        onClick={onClose}
        className={`absolute inset-0 z-40 bg-black/50 transition-opacity duration-300 ${open ? "opacity-100" : "opacity-0 pointer-events-none invisible"}`}
        data-testid="quick-action-scrim"
      />
      <div
        className={`absolute inset-x-0 bottom-0 z-50 max-w-[412px] mx-auto transition-transform duration-300 ease-out ${open ? "translate-y-0" : "translate-y-full pointer-events-none invisible"}`}
        data-testid="quick-action-drawer"
      >
        <div className="bg-cream border-t-4 border-charcoal rounded-t-3xl px-4 pt-4 pb-[104px] shadow-[0_-6px_0px_#1A1A1A] space-y-4">
          {/* Branding anchor */}
          <div className="flex items-center gap-2">
            <div className="flex-1">
              <p className="font-mono text-[9px] uppercase tracking-[0.3em] text-gold">Master Signature</p>
              <h2 className="font-serif text-2xl text-charcoal leading-none" data-testid="drawer-brand-title">MiSt Creation</h2>
            </div>
            <button onClick={onClose} data-testid="drawer-close-btn" className="w-11 h-11 min-w-[48px] min-h-[48px] grid place-items-center rounded-xl border-2 border-charcoal bg-white shadow-[2px_2px_0px_#1A1A1A] active:translate-x-[1px] active:translate-y-[1px] active:shadow-none"><X size={16} /></button>
          </div>

          {/* 2x2 macro vectors */}
          <div className="grid grid-cols-2 gap-3" data-testid="drawer-macro-grid">
            {MACRO_VECTORS.map((v) => (
              <button key={v.key} onClick={() => onAction(v.key)} data-testid={`macro-${v.key}`}
                className="flex flex-col items-start justify-center gap-1.5 min-h-[48px] bg-white border-2 border-charcoal rounded-2xl p-3.5 text-left shadow-[4px_4px_0px_#1A1A1A] active:translate-x-[3px] active:translate-y-[3px] active:shadow-none transition-[transform,box-shadow] duration-150">
                <span className="w-10 h-10 rounded-xl border-2 border-charcoal bg-gold text-black grid place-items-center shadow-[2px_2px_0px_#1A1A1A]"><v.icon size={19} strokeWidth={2.3} /></span>
                <span className="font-mono text-[11px] font-black uppercase tracking-[0.1em] text-charcoal leading-none mt-1">{v.label}</span>
                <span className="font-mono text-[8px] uppercase tracking-[0.14em] text-charcoal/45">{v.sub}</span>
              </button>
            ))}
          </div>

          {/* Full-width utility rows */}
          <div className="space-y-2.5">
            <button onClick={() => onAction("dashboard")} data-testid="macro-dashboard"
              className="w-full min-h-[48px] flex items-center gap-3 bg-charcoal text-white border-2 border-charcoal rounded-2xl px-4 py-3.5 shadow-[4px_4px_0px_#D4AF37] active:translate-x-[3px] active:translate-y-[3px] active:shadow-none transition-[transform,box-shadow] duration-150">
              <span className="w-9 h-9 rounded-lg border-2 border-gold text-gold grid place-items-center shrink-0"><LayoutDashboard size={17} strokeWidth={2.3} /></span>
              <span className="font-mono text-[12px] font-black uppercase tracking-[0.2em] flex-1 text-left">Command Centre</span>
            </button>

            <button onClick={() => onAction("logout")} data-testid="macro-logout"
              className="w-full min-h-[48px] flex items-center gap-3 border-2 border-charcoal rounded-2xl px-4 py-3.5 text-white shadow-[4px_4px_0px_#1A1A1A] active:translate-x-[3px] active:translate-y-[3px] active:shadow-none transition-[transform,box-shadow] duration-150"
              style={{ backgroundColor: "#FF4D4D" }}>
              <span className="w-9 h-9 rounded-lg border-2 border-white/70 grid place-items-center shrink-0"><LogOut size={17} strokeWidth={2.3} /></span>
              <span className="font-mono text-[12px] font-black uppercase tracking-[0.2em] flex-1 text-left">Logout</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
